// extracted by mini-css-extract-plugin
export default {"Snippet":"Snippet_Snippet__NzE0Y","Snippet__icon":"Snippet_Snippet__icon__NDE2Y","Snippet__title":"Snippet_Snippet__title__N2Q2M"};